import React from 'react';

interface TitanLogoProps {
  size?: number;
  className?: string;
  showText?: boolean;
}

export const TitanLogo: React.FC<TitanLogoProps> = ({ size = 40, className = '', showText = false }) => {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {/* Logo Icon */}
      <div className="relative">
        {/* Glow effect */}
        <div
          className="absolute inset-0 rounded-full blur-xl opacity-60 -z-10"
          style={{
            width: size,
            height: size,
            background: 'radial-gradient(circle, rgba(0, 230, 118, 0.4) 0%, transparent 70%)',
          }}
        />

        <svg
          width={size}
          height={size}
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Main T Shape Background - Dark Teal */}
          <path
            d="M10 8H30V14H23V32H17V14H10V8Z"
            fill="#006064"
            fillOpacity="0.4"
          />

          {/* T Shape Outline - Cyan/Teal */}
          <path
            d="M10 8H30V14H23V32H17V14H10V8Z"
            stroke="#006064"
            strokeWidth="2"
            strokeLinejoin="round"
          />

          {/* Growth Line / Pulse - Neon Green */}
          {/* Starts from bottom left, cuts through the T, goes up to top right */}
          <path
            d="M4 32 L14 32 L18 24 L22 28 L32 6"
            stroke="#00E676"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{
              filter: 'drop-shadow(0 0 4px rgba(0, 230, 118, 0.6))'
            }}
          />

          {/* Arrow head for the growth line */}
          <path
            d="M26 6 H32 V12"
            stroke="#00E676"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{
              filter: 'drop-shadow(0 0 4px rgba(0, 230, 118, 0.6))'
            }}
          />
        </svg>
      </div>

      {showText && (
        <span
          className="text-white font-black text-xl uppercase tracking-tighter"
          style={{
            textShadow: '0 0 10px rgba(0, 230, 118, 0.5), 0 2px 4px rgba(0, 0, 0, 0.5)',
          }}
        >
          TITAN MODE
        </span>
      )}
    </div>
  );
};
